module.exports = __webpack_public_path__ + "img/logo_malha_fina.a8942e8f.png";